import { Radio } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import {
  SELECT_BUTTON_SIZES,
  SELECT_BUTTON_TYPES,
  SelectButton,
} from 'shared_DEPRECATED/components/Form/SelectButton';
import { Spacers } from 'shared_DEPRECATED/components/Spacer';
import { Nullable } from 'shared_DEPRECATED/types';
import { dateUtils, range } from 'shared_DEPRECATED/utils';

import { CHECKBOX_BUTTONS_GAP, TARGET_TYPES } from 'features/challenge/config';
import {
  WeekdayTargetType,
  WeeklyTargetType,
} from 'features/challenge/config/types';

type ChallengeFrequencyDialogNumberWeeklyFieldProps = {
  frequency: {
    type: string;
    weekly: Nullable<WeeklyTargetType>;
    weekday: Nullable<WeekdayTargetType>;
  };
  onFrequencyChange: (frequency: { type: string; weekly: number }) => void;
};

export const ChallengeFrequencyDialogNumberWeeklyField = ({
  frequency,
  onFrequencyChange,
}: ChallengeFrequencyDialogNumberWeeklyFieldProps) => {
  const checked = frequency.type === TARGET_TYPES.WEEKLY;

  return (
    <Flex flexDirection="column" alignItems="start">
      <Radio
        value={TARGET_TYPES.WEEKLY}
        data-testid="challenge-frequency-weekly-radio"
      >
        Number of days weekly
      </Radio>
      <Spacers sizes={['sm zr', 'xsm zr']} />
      {checked && (
        <>
          <Flex justifyContent="start" gap={CHECKBOX_BUTTONS_GAP}>
            <Spacers sizes={['zr zr zr xsm']} />
            {range(1, dateUtils.WEEK_DAYS_COUNT).map((day) => {
              const checked = frequency.weekly === day;
              const onSelectButtonChange = () =>
                onFrequencyChange({
                  type: TARGET_TYPES.WEEKLY,
                  weekly: day,
                });

              return (
                <SelectButton
                  type={SELECT_BUTTON_TYPES.SINGLE}
                  checked={checked}
                  key={day}
                  minWidth="3.25rem"
                  onChange={onSelectButtonChange}
                  size={SELECT_BUTTON_SIZES.SM}
                  dataTestid={`challenge-frequency-daily-day-${day}`}
                >
                  {day}
                </SelectButton>
              );
            })}
          </Flex>
          <Spacers sizes={['sm zr', 'xsm zr']} />
        </>
      )}
    </Flex>
  );
};
